import React, { useState, useEffect } from "react";
import { Form, Button } from "antd";
import "./styles.scss";
import { Editor } from "@tinymce/tinymce-react";
import firebase from "firebase";
import ImageUploader from "./imageUploader";

const FormOriginal = (props) => {
  const { getFieldDecorator } = props.form;
  const [value, setValue] = useState("");
  const [content, setContent] = useState("");
  const [desc, setDescription] = useState("");
  const [slug, setSlug] = useState("");
  const [bImage, setB] = useState("");
  const [bTitle, setBTitle] = useState("");

  useEffect(() => {
    // Update the document title using the browser API
    if (props.defaultValues) {
      setContent(props.defaultValues.body);
      setB(props.defaultValues.bannerImage);
      setDescription(props.defaultValues.description);
      setSlug(props.defaultValues.slug);
      setBTitle(props.defaultValues.name);
    }
  }, []);

  // useEffect(() => {
  //   const ali = string_to_slug(bTitle);

  //   setSlug(ali);
  // });
  const handleUploadSuccess = (filename) => {
    setB(filename);
    //  this.setState({ avatar: filename, progress: 100, isUploading: false });
    firebase
      .storage()
      .ref("images")
      .child(filename)
      .getDownloadURL()
      .then((url) => setB(url));
  };
  getFieldDecorator("keys", {
    initialValue: props.defaultValues,
  });

  return (
    <div className="contactFormBlogWrapper">
      <div
        style={{
          alignItems: "center",
          justifyContent: "center",
          display: "flex",
        }}
      >
        <form
          className="contactFormBlog"
          onSubmit={(e) => props.handleSubmit(e, props.form)}
        >
          <div style={{ display: "flex", flexDirection: "row", width: "100%" }}>
            <div
              style={{ display: "flex", flex: "1", flexDirection: "column" }}
            >
              <Form.Item style={{ width: "100%" }} label="Blog Başlığı">
                {getFieldDecorator("title", {
                  initialValue:
                    props.defaultValues && props.defaultValues.title,
                  rules: [
                    {
                      required: true,
                      message: "Please input your product name!",
                    },
                  ],
                })(
                  <input
                    placeholder="Blog Başlığı"
                    className="contactFormBlogInput"
                  />
                )}
              </Form.Item>

              <Form.Item style={{ width: "100%" }} label="Blog Kisa Aciklamasi">
                {getFieldDecorator("description", {
                  initialValue:
                    props.defaultValues && props.defaultValues.description,
                  rules: [
                    {
                      required: true,
                      message: "Please input your product name!",
                    },
                  ],
                })(
                  <textarea
                    placeholder="Blog Başlığı"
                    className="contactFormBlogTextArea"
                  />
                )}
              </Form.Item>
            </div>
            <div style={{ display: "flex", flex: "1" }}>
              <Form.Item style={{ width: "100%" }} label="Blog Gorseli">
                <ImageUploader
                  imageUrl={bImage}
                  success={handleUploadSuccess}
                />
              </Form.Item>
            </div>
          </div>
          <Form.Item style={{ width: "100%" }} label="Urun Aciklamasi">
            <Editor
              apiKey="s825g6h8k9anaemejf0288g84rkn8sjlcskvbnhu7y00uphp"
              initialValue={content}
              init={{
                height: 600,
                menubar: true,
                plugins: [
                  "advlist autolink lists link image charmap print preview anchor",
                  "searchreplace visualblocks code fullscreen",
                  "insertdatetime media table paste code help wordcount",
                ],
                toolbar:
                  "undo redo | formatselect | bold italic backcolor | \
             alignleft aligncenter alignright alignjustify | \
             bullist numlist outdent indent | removeformat | help",
              }}
              onEditorChange={(val) => setContent(val)}
            />
          </Form.Item>
          {getFieldDecorator("bannerImage", {
            initialValue: bImage,
          })}

          {getFieldDecorator("body", {
            initialValue: content,
          })}
          <Form.Item style={{ width: "100%" }}>
            <Button
              type="primary"
              htmlType="submit"
              className="login-form-button"
            >
              {props.type}
            </Button>
          </Form.Item>
        </form>
      </div>
    </div>
  );
};
const WrappedNormalLoginForm = Form.create({ name: "productCreate" })(
  FormOriginal
);

export default WrappedNormalLoginForm;
